import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Stack from "../ui/Stack";
import { logout } from '../../store/auth-slice';

const Header = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { admin } = useSelector((state) => state.auth);

    const handleLogout = () => {
        dispatch(logout());
        navigate("/login", { replace: true });
    };

    return (
        <Stack className="column-gap-3 align-items-center justify-content-between">
            <Stack className="align-items-center column-gap-2">
                <h5 className="mb-0">Formlyze</h5>
                <span className="badge bg-primary bg-opacity-10 text-primary fw-normal small">Admin</span>
            </Stack>

            <Stack className="align-items-center column-gap-3">
                {admin && (
                    <span className="text-muted small d-none d-md-inline">
                        {admin.name || admin.email}
                    </span>
                )}
                <button
                    className="btn btn-sm btn-outline-secondary"
                    onClick={handleLogout}
                    title="Sign out"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 24 24" className="me-1">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
                        <polyline points="16 17 21 12 16 7"/>
                        <line x1="21" y1="12" x2="9" y2="12"/>
                    </svg>
                    Sign out
                </button>
            </Stack>
        </Stack>
    );
};

export default Header;
